<template>
  <div>
    <div>
      <el-form ref="formFilter" :model="formFilter" label-width="75px" label-position="right" @submit.native.prevent>
        <filter-box :item-width="300">
          <el-form-item label="申请日期">
            <date-range class="filter-item" v-model="formFilter.createDate" :clearable="true" :allowTypes="['day']"
              align="left" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd"
              value-format="yyyy-MM-dd HH:mm:ss" />
          </el-form-item>
          <el-button slot="operator" type="default" @click="onReset()" :plain="true">重置</el-button>
          <el-button slot="operator" type="primary" @click="onSearch()" :plain="true">查询</el-button>
        </filter-box>
      </el-form>
    </div>
    <div id="myChart" :style="{ width: '100%', height: '600px' }"></div>
    <div>
      <el-table header-cell-class-name="table-header-gray" :data="tableHead">
        <el-table-column label="变更类别" prop="name" sortable="custom">
        </el-table-column>
        <el-table-column label="变更次数" prop="barData"> </el-table-column>
        <el-table-column label="累计百分比 %" prop="lineData"> </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { findTreeNodePath } from "@/utils";
import { uploadMixin } from "@/core/mixins";
import {
  changeReportController
} from "@/api";
export default {
  props: {
    rowData: Object,
  },
  mixins: [uploadMixin],
  data() {
    return {
      formFilter: {
        createDate: [],
      },
      tableHead: [],
    };
  },
  methods: {
    onSearch() {
      console.log(55);
      var date = this.formFilter.createDate;
      var params = {};
      if (date.length > 0) {
        params['startTime'] = date[0];
        params['endTime'] = date[1];
      }
      this.loadData(params);
    },
    initData(data) {
      let myChart = this.$echarts.init(document.getElementById('myChart'));
      var total = 0;
      var set = [];
      var xAxis = [];
      for (var f in data) {
        xAxis.push(f);
        total += data[f];
        set.push(data[f]);
      }

      var fold = 0;
      var lineData = [];
      var barData = [];
      for (var i = 0; i < set.length; i++) {
        console.log(total);
        var quantity = set[i];
        fold += quantity;
        console.log(total);
        var probability = 0;
        var proportion = 0;
        if (fold != 0) {
          probability = (parseInt(((fold / total) * 100) + '', 0));
          proportion = (parseInt(((quantity / total) * 100) + '', 0));
        }
        barData.push(quantity);
        lineData.push(probability);
      }

      var head = [];
      for (var i = 0; i < xAxis.length; i++) {
        head.push({ "name": xAxis[i], "barData": barData[i], "lineData": lineData[i] });
      }

      this.tableHead = head;

      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
          data: ['变更次数', "累计百分比"]
        },
        xAxis: [
          {
            type: 'category',
            data: xAxis,
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '变更次数',
            min: 0,
            scale: true,
            axisLabel: {
              formatter: '{value}'
            }
          },
          {
            type: 'value',
            name: '累计百分比',
            min: 0,
            scale: true,
            axisLabel: {
              formatter: '{value} %'
            }
          }
        ],
        series: [
          {
            color: ['#3398DB'],
            name: '变更次数',
            type: 'bar',
            yAxisIndex: 0,
            data: barData
          },
          {
            color: ['#FF0000'],
            name: '累计百分比',
            type: 'line',
            smooth: true,
            yAxisIndex: 1,
            data: lineData
          }
        ]
      };
      myChart.setOption(option);
    },
    loadData(params) {
      var _that = this;
      changeReportController.ploat(this, params)
        .then((res) => {
          console.log(res.data);
          _that.initData(res.data);
        })
        .catch((e) => {

        });
    },
    onReset () {
      this.formFilter.createDate=[];
      this.onSearch();
    },
  },
  computed: {
    isEdit() {
      return this.formData.userId != null;
    },
  },
  mounted() {
    this.loadData({});
  }
};
</script>

<style lang="scss" scoped></style>
